/**
 * Das Klopfzeichen — sieben Treffer auf die Wortmarke öffnen das Easter Egg.
 *
 * WARUM DAS EINE EIGENE DATEI IST UND NICHT DREI ZEILEN IN EINER KOMPONENTE.
 * Weil es eine Regel ist und keine Darstellung: wie viele Treffer, in welchem
 * Zeitfenster, ab wann es sich meldet. Als Zeilen in einem Klick-Handler war
 * genau das nicht prüfbar — und der erste Versuch, es im Browser zu prüfen,
 * scheiterte an etwas, das mit der Regel nichts zu tun hatte: die Seite rechnet
 * eine 3D-Szene, ein Klick dauert dort länger als das Zeitfenster, und die
 * Zählung begann bei jedem Klick von vorn. Der Fehler lag im Messaufbau, nicht
 * im Code — sichtbar wurde das erst, als die Regel ohne Browser lief.
 *
 * DAS ZEITFENSTER IST DER GRUND, WARUM ES ÜBERHAUPT EINE REGEL IST. Ohne es
 * summierten sich Klicks über den ganzen Arbeitstag, und irgendwann öffnete sich
 * das Spiel bei jemandem, der nur oft genug auf die Kopfzeile getippt hat.
 */

/** So oft muss die Wortmarke getroffen werden. */
export const KNOCKS = 7

/** Länger als das zwischen zwei Treffern, und die Zählung beginnt von vorn. */
export const KNOCK_WINDOW = 2600

/**
 * Ab wie vielen Treffern sich der Zähler meldet.
 *
 * Vorher ist NICHTS zu sehen: wer die Kopfleiste nur anfasst, soll nicht
 * erfahren, dass es etwas zu finden gibt. Ab dem dritten Treffer ist die Absicht
 * eindeutig — und ohne jede Rückmeldung fände auch niemand die restlichen vier.
 */
export const KNOCK_HINT_AT = 3

export interface KnockState {
  count: number
  /** Zeitstempel des letzten Treffers, ms. */
  last: number
}

export const knockStart = (): KnockState => ({ count: 0, last: -Infinity })

export interface KnockResult {
  state: KnockState
  /** Wie viele noch fehlen. 0, wenn es aufgeht. */
  remaining: number
  /** Jetzt öffnen. */
  open: boolean
  /** Den Zähler zeigen — erst ab `KNOCK_HINT_AT`. */
  hint: boolean
}

/**
 * Ein Treffer.
 *
 * `now` kommt herein und wird nicht gelesen: dieselbe Regel wie im übrigen Kern,
 * und der einzige Weg, ein Zeitfenster zu prüfen, ohne zu warten.
 */
export function knockStep(state: KnockState, now: number): KnockResult {
  const fresh = now - state.last > KNOCK_WINDOW
  const count = (fresh ? 0 : state.count) + 1

  if (count >= KNOCKS) {
    /* Aufgegangen — und der Zähler beginnt von vorn, damit ein zweiter Lauf
       nicht nach einem einzigen Klick startet. */
    return { state: knockStart(), remaining: 0, open: true, hint: false }
  }

  const remaining = KNOCKS - count
  return {
    state: { count, last: now },
    remaining,
    open: false,
    hint: count >= KNOCK_HINT_AT,
  }
}
